import ProviderAppointmentList from '../index';
import { enhance } from './enhance';

export default enhance(ProviderAppointmentList);



// WEBPACK FOOTER //
// ./src/components/Healthboard/ProviderAppointmentList/AppointmentProviderHistory/index.jsx